<template>
  <TsSection append-class="bg-idle-white">
    <TsBreadcrumb :data="breadcrumb_links" dataTestid="pro-card-breadcrumb" />

    <TsRow appendClass="p-0 pl-2 pt-5">
      <TsTitle title="Apply for a PRO Card" />
    </TsRow>

    <TsColumn append-class="bg-info-dark-border p-6 md:mx-4 mt-2 mb-10">
      <TsRow appendClass="justify-center">
        <TsImage src="/images/thankyou.webp" width="110" height="110" class="mx-auto" loading="lazy"/>
      </TsRow>
      <TsRow append-class="justify-center">
        <TsTypography align="center" append-class="text-primary" as="h1"> Thank
          you for submitting <br> your application!
        </TsTypography>
      </TsRow>  
      <TsRow append-class="justify-center" v-if="proCardStore.pro_card_type === 'PROCARD'">
        <TsTypography align="center" append-class="text-primary text-lg">
          You wil recieve a response in 5 working days
        </TsTypography>
      </TsRow>
    </TsColumn>
    <TsRow class="gap-2 justify-center pb-10">
      <TsButton append-class="px-12 whitespace-nowrap" :label="goBacktoAccount" link="/account/pro-card" />
    </TsRow>
  </TsSection>
</template>


<script setup lang="ts">
const authStore = useAuthStore();
const proCardStore = useProCardStore();
import data from "~/json/pro_card_labels.json";
import proCardApplicationData from "~/json/pro_card_data.json";
import {ProCardServiceType} from "~/stores/pro-card.store"
import { useTranslation } from "~/composables/useTranslation";

const TsBreadcrumb = defineAsyncComponent(() => import('~/components/molecules/TsBreadcrumb.vue'));
const goBacktoAccount = useTranslation("goBacktoAccount" , "Ga terug naar mijn account")

definePageMeta({
  middleware: ["is-logged-in"]
});

const breadcrumb_links = [
  {
    text: useTranslation('home','Thuis'),
    link: '/'
  }, {
    text: 'Pro Card',
    link: getContentSlug('pro')
  }, {
    text: 'Apply For Pro Card',
    link: '/pro-card/application'
  }
];

onMounted(async () => {
  if (authStore.user.id) {
    await authStore.fetchOneTimeQrCode(authStore.user.id);
    await proCardStore.fetchApplicationStatus();

    // GTM event for pro card
    logEvent({
      options: {
        eventAction: "page_view",
        eventProperties: {
          user:authStore.user
        },
        eventInteraction: true,
        eventLabel: `User succesfully apply for the pro card`,
        eventName: "pro_card",
      },
    });
  }

})

onUnmounted(() => {
  proCardStore.pro_card_type = "";
  proCardStore.application_labels_data = data;
  proCardStore.pro_application_data = proCardApplicationData;
  proCardStore.pro_application_data.form_data.application_data.company_details.company_name = "";
})

</script>